import React, { Component } from 'react'
import { Textfield } from 'react-mdl'

class SearchBar extends Component {
  handleSearchChange = ({ target }) => {
    this.props.onSearchChange(target.value)
  }
  handleSearchSubmit = e => {
    if (e.charCode === 13) {
      this.props.onSearch()
    }
  }
  render() {
    const { searchTerm, searching } = this.props
    return (
      <div>
        <Textfield
          onChange={this.handleSearchChange}
          onKeyPress={this.handleSearchSubmit}
          value={searchTerm}
          label="Search..."
        />
        {searching ? <p>Searching...</p> : null}
      </div>
    )
  }
}

export default SearchBar



// WEBPACK FOOTER //
// ./src/components/SearchBar.js